// Package Imports
import axios from "axios";

// Project Imports
import * as APITypes from "constants/API";
import StorageKeys from "../../../../constants/StorageKeys";
import generateAddNeedDataStructure from "./generateAddNeedDataStructure";
import updateAddNeedFamilyProductId from "./updateAddNeedFamilyProductId";
import AuthStore from "modules/login/store/AuthStore";
import { toJS } from "mobx";

const generateAddNeedFamilyProductId = async (data, hideModal, needType) => {
  
  
  await AuthStore.fetchJourneyData()
  const journeyData = toJS(AuthStore.journeyData);
  
  generateAddNeedDataStructure(data, needType);
  if (hideModal) hideModal()

  // API Call
  const apiResponse = await axios.post(
    APITypes.CREATE_FAMILY_PRODUCT_ID,
    data
  );
  if (apiResponse.data.status.toLowerCase() === "success") {
    localStorage.setItem(
      StorageKeys.FIRST_TIME_OPTIMIZATION_PAGE_LOAD_PARAM,
      false
    );
    updateAddNeedFamilyProductId(data, apiResponse.data, needType);
  }
};

export default generateAddNeedFamilyProductId;
